

import { Box, Drawer, DrawerBody, DrawerContent, DrawerHeader, DrawerOverlay, Flex, Heading, Step, StepDescription, StepIcon, StepIndicator, StepNumber, Stepper, StepSeparator, StepStatus, StepTitle, Tab, TabList, TabPanel, TabPanels, Tabs } from '@chakra-ui/react';
import { useCallback, useEffect, useMemo, useState } from 'react';
import moment from 'moment';
import { IconButton } from '@material-ui/core';
import { MdClose, MdContentCopy } from 'react-icons/md';

import { entityBaseBodyRender, Table, TableGroupRowData } from '@app/components/common/table';
import { isGroupRow } from '@app/components/common/table/utils';
import { ConfirmRemoveDialog, FieldView, Txt } from '@app/components/common';
import { USER_DATE_FORMAT } from '@app/utils';
import { Equipment, MasterOutlet, UserInfo } from '@app/api/models';
import { useQueryTable } from '@app/components/common/table/query-table';
import { Transaction } from '@app/api/models/transaction';
import { useAlert, useApi } from '@app/hooks';
import { Activity } from '@app/api/socket-service';

import { getActivityTitle } from '../utils/get-activity-title';
import { ActivityGallery } from './gallery';
import { UserInfoBlock } from './user-info';
import { EquipInfo } from './equip-info';
import { OutletInfo } from './outlet-info';

export const ActivityDrawer = ({ 
  selectedActivity,
  onClose,
  onShowOutletOnMap,
 }: {
  selectedActivity?: Activity;
  onClose(): void;
  onShowOutletOnMap(location: [number, number]): void;
}) => {

  if (!selectedActivity) {return null;}

  return <>
    <Drawer placement='right' onClose={onClose} isOpen={!!selectedActivity}>
      <DrawerOverlay />
      <DrawerContent minW={450}>
        <DrawerHeader borderBottomWidth='1px'>
          <Box display='flex' justifyContent='space-between' alignItems='center'>
            <Txt color='brand.500'>{getActivityTitle(selectedActivity.activity)}</Txt>
            <IconButton onClick={onClose} aria-label="close">
              <MdClose color='gray.500' />
            </IconButton>
          </Box>
        </DrawerHeader>
        <DrawerBody display='flex' flexDirection='column' justifyContent='space-between' >
          <Box>
            <UserInfoBlock
              username={selectedActivity.username.split('-')[0]}
              date={moment(selectedActivity.timestamp / 1000).format(USER_DATE_FORMAT)}
            />
            <Tabs mx={-6}>
              <TabList >
                <Tab>ХО</Tab>
                <Tab>ТТ</Tab>
                <Tab>Транзакции</Tab>
              </TabList>
              <TabPanels>
                <TabPanel>
                  <Box>
                    <Box display='flex' justifyContent='space-between' mt={0} pb={4} alignItems='center'>
                      <ActivityGallery photoHashes={selectedActivity.photos} />
                    </Box>
                    <Box>
                      <EquipInfo serialNumber={selectedActivity.entityId} />
                    </Box>
                   
                  </Box>
                </TabPanel>
                <TabPanel>
                  <OutletInfo 
                    serialNumber={selectedActivity.entityId} 
                    onShowOutletOnMap={onShowOutletOnMap}
                  />
                </TabPanel>
                <TabPanel>
                  <Box mx={-4}>
                    {/* <Table<Equipment>
                      title={<Txt fontSize='medium'>Холодильное оборудование</Txt>}
                      columns={[
                        { name: 'id', label: '#', options: { filter: false } },
                        { name: 'model', label: 'Модель', options: { customBodyRender: entityBaseBodyRender() } },
                        { name: 'inventory_num', label: 'Инв.номер', options: { filter: true } },
                        { name: 'serial_num', label: 'Серийный номер', options: { filter: true } },
                        { name: 'id', label: '', options: { 
                            filter: false,
                            customBodyRender: (id) => <ConfirmRemoveDialog 
                              text='Исключить ХО из пакета?' 
                              buttonText='Исключить'
                              onRemove={onRemove(id)} 
                            />
                          }   
                        }
                      ]} 
                      data={selectedTx.items.map(({ equip }) => equip )}
                      paper={false}
                    /> */}
                  </Box>
                </TabPanel>
              </TabPanels>
            </Tabs>
          </Box>
        </DrawerBody>
      </DrawerContent>
    </Drawer>
  </>;
};